import { useState } from "react";
import { FileDetails } from "@/types/types";
import { useUploadReceiptProofMutation } from "@/redux/feature/orderManagement/productShipping/productShippingApi";
import { handleApiRequest } from "@/utils/handleApiRequest";
import toast from "react-hot-toast";

export const useFileUpload = (orderId: string, videoId: string) => {
  const [file, setFile] = useState<FileDetails | null>(null);
  const [loading, setIsLoading] = useState(false);
  const [uploadReceiptProof] = useUploadReceiptProofMutation();

  const handleUploadReceiptProof = async () => {
    if (!file?.live_url) {
      return toast.error("Please upload the proof!");
    }

    const payload = {
      order_id: orderId,
      video_id: videoId,
      data: {
        product_receipt_proof: file,
      },
    };

    setIsLoading(true);
    await handleApiRequest({
      payload,
      requestFunction: uploadReceiptProof,
      onSuccess: () => {
        toast.success("Uploaded");
        setIsLoading(false);
      },
      onError: (err) => {
        toast.error(err.data.message || "Something went wrong");
        setIsLoading(false);
      },
    });
  };
  const handleConfirmReceived = async () => {
    const payload = {
      order_id: orderId,
      video_id: videoId,
      data: {
        product_receipt_proof: null,
      },
    };

    setIsLoading(true);
    await handleApiRequest({
      payload,
      requestFunction: uploadReceiptProof,
      onSuccess: () => {
        toast.success("Uploaded");
        setIsLoading(false);
      },
      onError: (err) => {
        toast.error(err.data.message || "Something went wrong");
        setIsLoading(false);
      },
    });
  };

  return {
    file,
    setFile,
    loading,
    handleUploadReceiptProof,
    handleConfirmReceived,
  };
};
